import PharmacyVendorsPage from "@/pages/pharmacy/PharmacyVendorsPage";

export default function VendorsPage() {
  return <PharmacyVendorsPage basePath="/pharmacist" />;
}
